import { LoadPaymentDetailsLoading } from '../../../../OutboundWire/ui/LoadPaymentDetailsWidget/LoadPaymentDetailsLoading';
import NoPaymentDetailsIcon from '@/images/NoItemsIcon.svg?react';
import { PaymentDetailsWrapper } from './styles';
import { Notification } from '@/components/Notification/Notification';
import { DEPOSIT_ACCOUNT_STATUS_DB } from '@/const/wire';
import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { ResponseErrorType } from '@/types/sharedTypes';
import { DetailsWidget } from '@/components/DetailsWidget/DetailsWidget';
import { NoResults } from '@/components/NoResults/NoResults';
import { DepositAccountStatusType } from '@/types/wireTypes';
import { PaymentDetailsData } from '@/bundle/shared/components/PaymentDetailsData/PaymentDetailsData';
import { ErrorSupportNotification } from '@/bundle/shared/components/ErrorSupportNotification/ErrorSupportNotification';

type DepositAccountPaymentDetailsType = {
  status: DepositAccountStatusType;
  paymentDetails: PaymentDetailsGeneralType;
  isLoading: boolean;
  error?: ResponseErrorType;
};

export const DepositAccountPaymentDetails = ({
  status,
  paymentDetails,
  isLoading,
  error,
}: DepositAccountPaymentDetailsType) => {
  const isFailedStatus = status === DEPOSIT_ACCOUNT_STATUS_DB.FAILED;
  const isPendingStatus = status === DEPOSIT_ACCOUNT_STATUS_DB.PENDING;
  const isActiveStatus = status === DEPOSIT_ACCOUNT_STATUS_DB.ACTIVE;
  const isInactiveStatus = status === DEPOSIT_ACCOUNT_STATUS_DB.INACTIVE;
  const isDataFromBlockchain = paymentDetails?.is_blockchain_payment_details_data_from_bc;

  const hasPaymentDetails = isActiveStatus || isInactiveStatus;
  const hasDetails = !isLoading && !error;
  const hasBlockchainDetails = hasDetails && isDataFromBlockchain;
  const hasDatabaseDetails = hasDetails && isDataFromBlockchain === false;

  if (isPendingStatus) {
    return (
      <NoResults
        icon={<NoPaymentDetailsIcon />}
        message='This receiving account has been submitted to the WireVault blockchain.'
        marginTop={84}
      />
    );
  }

  return (
    <PaymentDetailsWrapper>
      <DetailsWidget header='Wire Info'>
        {isLoading && <LoadPaymentDetailsLoading />}

        {isFailedStatus && <ErrorSupportNotification verticalAlign='center' />}

        {hasPaymentDetails && hasBlockchainDetails && (
          <Notification variant='success' fontVariant='medium' verticalAlign='center' marginBottom='20px'>
            Stored in the WireVault blockchain.
          </Notification>
        )}

        {hasPaymentDetails && hasDatabaseDetails && (
          <Notification variant='info-secondary' marginBottom='20px'>
            The WireVault blockchain is unavailable. The wire info cannot be confirmed at this time. Please try again
            later.
          </Notification>
        )}

        {hasPaymentDetails && hasDetails && <PaymentDetailsData paymentDetails={paymentDetails} />}
      </DetailsWidget>
    </PaymentDetailsWrapper>
  );
};
